/* KRVVY native cart drawer (extracted from sections/flo-cart-drawer.liquid so the browser can cache it).
   Config (money format, routes, gift goals, rewards) is set inline by the section as window.__FNCD_CONFIG. */
(function () {
  'use strict';
  if (window.FloNativeCart) return;

  var CONFIG = window.__FNCD_CONFIG || {};

  var root = document.getElementById('fncd-root');
  if (!root) return;
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  var els = {
    itemsList: $('[data-fncd-items]'),
    countLabel: $('[data-fncd-count-label]'),
    empty: $('[data-fncd-empty]'),
    filled: $('[data-fncd-filled]'),
    footer: $('[data-fncd-footer]'),
    total: $('[data-fncd-total]'),
    breakdown: $('[data-fncd-breakdown]'),
    savings: $('[data-fncd-savings]'),
    savingsAmount: $('[data-fncd-savings-amount]'),
    savingsBreakdown: $('[data-fncd-savings-breakdown]'),
    rewardsAmount: $('[data-fncd-rewards-amount]'),
    goals: $('[data-fncd-goals]'),
    couponInput: $('[data-fncd-coupon-input]'),
    couponApply: $('[data-fncd-coupon-apply]'),
    couponError: $('[data-fncd-coupon-error]'),
    couponApplied: $('[data-fncd-coupon-applied]'),
    couponCode: $('[data-fncd-coupon-code]'),
    toast: $('[data-fncd-toast]')
  };

  var state = { cart: null, open: false, busy: false };

  /* ---------- utils ---------- */
  function formatMoney(cents) {
    var format = CONFIG.moneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/<[^>]*>/g, '');
  }
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imageUrl(src, width) {
    if (!src) return '';
    return src.indexOf('?') > -1 ? src + '&width=' + width : src + '?width=' + width;
  }
  var toastTimer;
  function showToast(msg) {
    if (!els.toast) return;
    els.toast.textContent = msg;
    els.toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { els.toast.classList.remove('is-visible'); }, 3000);
  }

  /* ---------- API ---------- */
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || 'Request failed'); err.data = data; throw err; }
        return data;
      });
    });
  }
  /* KRVVY: per-cart { variant_id: colour-cover-url } map so line items show the SELECTED colour, not the
     product default (variants have no native image). Seeded from #krvvy-cart-vimg-data (rendered in the
     layout) and re-fetched via the Section Rendering API on every cart read so live-added items get it. */
  function readCmp() { try { var el = document.getElementById('krvvy-cart-cmp-data'); return el ? (JSON.parse(el.textContent || '{}') || {}) : {}; } catch (e) { return {}; } }
  var cmpMap = readCmp();
  function readVimg() { try { var el = document.getElementById('krvvy-cart-vimg-data'); return el ? (JSON.parse(el.textContent || '{}') || {}) : {}; } catch (e) { return {}; } }
  var vimgMap = readVimg();
  function refreshVimg() {
    return fetch(location.pathname + '?sections=krvvy-cart-vimg')
      .then(function (r) { return r.json(); })
      .then(function (j) { var html = j && j['krvvy-cart-vimg']; if (!html) return;
        var m = html.match(/id="krvvy-cart-vimg-data"[^>]*>([\s\S]*?)<\/script>/); if (m) { try { vimgMap = JSON.parse(m[1]) || {}; } catch (e) {} }
        // the same section carries the compare-at map, so refresh it on every cart change too
        var c = html.match(/id="krvvy-cart-cmp-data"[^>]*>([\s\S]*?)<\/script>/); if (c) { try { cmpMap = JSON.parse(c[1]) || {}; } catch (e) {} }
      })
      .catch(function () {});
  }
  function getCart() { return fetchJSON(CONFIG.routes.cartGet + '?t=' + Date.now()).then(function (cart) { return refreshVimg().then(function () { return cart; }); }); }
  function changeLine(key, quantity) {
    return fetchJSON(CONFIG.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }
  function addItem(variantId) {
    return fetchJSON(CONFIG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
  }
  function updateDiscount(codes) {
    return fetchJSON(CONFIG.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes })
    });
  }

  /* ---------- render ---------- */
  var TRASH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="rgba(39, 39, 42, 50%)" viewBox="0 0 256 256"><path d="M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z"></path></svg>';
  var MINUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#4d4d4d" viewBox="0 0 256 256"><path d="M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128Z"></path></svg>';
  var PLUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#4d4d4d" viewBox="0 0 256 256"><path d="M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z"></path></svg>';
  var GIFT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#ffffff" viewBox="0 0 256 256"><path d="M216,72H180.92c.39-.33.79-.65,1.17-1A29.53,29.53,0,0,0,192,49.57,32.62,32.62,0,0,0,158.44,16,29.53,29.53,0,0,0,137,25.91a54.94,54.94,0,0,0-9,14.48,54.94,54.94,0,0,0-9-14.48A29.53,29.53,0,0,0,97.56,16,32.62,32.62,0,0,0,64,49.57,29.53,29.53,0,0,0,73.91,71c.38.33.78.65,1.17,1H40A16,16,0,0,0,24,88v32a16,16,0,0,0,16,16v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM149,36.51a13.69,13.69,0,0,1,10-4.5h.49A16.62,16.62,0,0,1,176,49.08a13.69,13.69,0,0,1-4.5,10c-9.49,8.4-25.24,11.36-35,12.4C137.7,60.89,141,45.5,149,36.51Zm-64.09.36A16.63,16.63,0,0,1,96.59,32h.49a13.69,13.69,0,0,1,10,4.5c8.39,9.48,11.35,25.2,12.39,34.92-9.72-1-25.44-4-34.92-12.39a13.69,13.69,0,0,1-4.5-10A16.6,16.6,0,0,1,84.87,36.87ZM40,88h80v32H40Zm16,48h64v64H56Zm144,64H136V136h64Zm16-80H136V88h80v32Z"></path></svg>';

  function renderItem(item, index) {
    // Never render a zero-quantity ghost line (its line price is 0 and would be mislabelled a free gift).
    if (!item || item.quantity <= 0) return '';
    // A line is a free gift ONLY if it's a configured gift variant, or a genuinely discounted line (qty>0, price 0).
    var isFree = isGiftVariant(item.variant_id) || (item.quantity > 0 && item.final_line_price === 0);
    var entering = pendingGiftEnter && item.variant_id === pendingGiftEnter;
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    // Customer-facing line properties (e.g. Essential Preorder's "Note: Preorder"); keys starting with _ are hidden by convention.
    var propsHtml = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (!k || k.charAt(0) === '_' || v === null || v === '' || typeof v === 'object') return;
        propsHtml += '<div class="fncd-item__prop">' + escapeHtml(k) + ': ' + escapeHtml(String(v)) + '</div>';
      });
    }
    var _vsrc = (vimgMap && vimgMap[item.variant_id]) || item.image;
    var img = _vsrc ? '<img src="' + escapeHtml(imageUrl(_vsrc, 160)) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
    var priceHtml = isFree
      ? '<span class="fncd-item__price fncd-item__price--free">FREE!</span>'
      : (function () {
          // compare-at is per unit; the line shows unit x qty, so scale it to match
          var cmpUnit = cmpMap && cmpMap[item.variant_id];
          var cmpLine = cmpUnit ? cmpUnit * item.quantity : 0;
          var was = (cmpLine > item.final_line_price)
            ? '<span class="fncd-item__compare">' + formatMoney(cmpLine) + '</span>'
            : '';
          return was + '<span class="fncd-item__price">' + formatMoney(item.final_line_price) + '</span>';
        })();
    var giftBadge = isFree ? '<div class="fncd-gift-badge">' + GIFT_SVG + '</div>' : '';
    var actions;
    if (isFree) {
      actions =
        '<div class="fncd-qty">' +
          '<button type="button" class="fncd-qty__btn" disabled>' + MINUS_SVG + '</button>' +
          '<p class="fncd-qty__count">' + item.quantity + '</p>' +
          '<button type="button" class="fncd-qty__btn" disabled>' + PLUS_SVG + '</button>' +
        '</div>';
    } else {
      actions =
        '<button type="button" class="fncd-trash" aria-label="Remove item" data-fncd-remove="' + index + '">' + TRASH_SVG + '</button>' +
        '<div class="fncd-qty">' +
          '<button type="button" class="fncd-qty__btn" aria-label="Decrease quantity" data-fncd-minus="' + index + '">' + MINUS_SVG + '</button>' +
          '<p class="fncd-qty__count">' + item.quantity + '</p>' +
          '<button type="button" class="fncd-qty__btn" aria-label="Increase quantity" data-fncd-plus="' + index + '">' + PLUS_SVG + '</button>' +
        '</div>';
    }
    return (
      '<li data-fncd-line="' + index + '">' +
        '<div class="fncd-item' + (entering ? ' fncd-item--enter' : '') + '">' +
          '<div class="fncd-item__media">' + giftBadge +
            (isFree
              ? '<div class="fncd-item__img fncd-item__img--static">' + img + '</div>'
              : '<a href="' + escapeHtml(item.url) + '"><div class="fncd-item__img">' + img + '</div></a>') +
          '</div>' +
          '<div class="fncd-item__content">' +
            '<div class="fncd-item__row">' +
              '<div style="min-width:0;">' +
                (isFree
                  ? '<span class="fncd-item__title fncd-item__title--static">' + escapeHtml(item.product_title) + '</span>'
                  : '<a class="fncd-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>') +
                (variantTitle ? '<div class="fncd-item__variant">' + escapeHtml(variantTitle) + '</div>' : '') +
                propsHtml +
              '</div>' +
              '<div class="fncd-item__prices">' + priceHtml + '</div>' +
            '</div>' +
            '<div class="fncd-item__actions">' + actions + '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function collectDiscounts(cart) {
    var lines = {};
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var title = alloc.discount_application && alloc.discount_application.title ? alloc.discount_application.title : 'Discount';
        lines[title] = (lines[title] || 0) + alloc.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      var title = app.title || 'Discount';
      lines[title] = (lines[title] || 0) + (app.total_allocated_amount || 0);
    });
    return Object.keys(lines).map(function (title) { return { title: title, amount: lines[title] }; });
  }

  /* ---------- free gift goals ---------- */
  var SHIELD_GIFT = '<svg viewBox="0 0 32 36" width="30" height="34" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<path d="M3 4.2C3 3.26 3.76 2.5 4.7 2.5H27.3C28.24 2.5 29 3.26 29 4.2V21.6C29 23 28.28 24.3 27.1 25.02L17.05 31.2C16.4 31.6 15.6 31.6 14.95 31.2L4.9 25.02C3.72 24.3 3 23 3 21.6V4.2Z" fill="#fff" stroke="currentColor" stroke-width="1.7"/>'
    + '<g fill="currentColor" transform="translate(8.6,7.6) scale(0.058)"><path d="M216,72H180.92c.39-.33.79-.65,1.17-1A29.53,29.53,0,0,0,192,49.57,32.62,32.62,0,0,0,158.44,16,29.53,29.53,0,0,0,137,25.91a54.94,54.94,0,0,0-9,14.48,54.94,54.94,0,0,0-9-14.48A29.53,29.53,0,0,0,97.56,16,32.62,32.62,0,0,0,64,49.57,29.53,29.53,0,0,0,73.91,71c.38.33.78.65,1.17,1H40A16,16,0,0,0,24,88v32a16,16,0,0,0,16,16v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM149,36.51a13.69,13.69,0,0,1,10-4.5h.49A16.62,16.62,0,0,1,176,49.08a13.69,13.69,0,0,1-4.5,10c-9.49,8.4-25.24,11.36-35,12.4C137.7,60.89,141,45.5,149,36.51Zm-64.09.36A16.63,16.63,0,0,1,96.59,32h.49a13.69,13.69,0,0,1,10,4.5c8.39,9.48,11.35,25.2,12.39,34.92-9.72-1-25.44-4-34.92-12.39a13.69,13.69,0,0,1-4.5-10A16.6,16.6,0,0,1,84.87,36.87ZM40,88h80v32H40Zm16,48h64v64H56Zm144,64H136V136h64Zm16-80H136V88h80v32Z"></path></g></svg>';

  function amtLabel(cents) { return formatMoney(cents).replace(/\.00$/, ''); }

  function initGoals() {
    var wrap = els.goals;
    if (!wrap || wrap.dataset.built === '1' || !CONFIG.showGiftGoals || !CONFIG.giftGoals.length) return;
    wrap.dataset.built = '1';
    var n = CONFIG.giftGoals.length;
    var marks = CONFIG.giftGoals.map(function (g, i) {
      var pos = (i + 1) * (100 / n);
      var cls = 'fncd-goals__mark' + (i === n - 1 ? ' is-last' : '');
      return '<li class="' + cls + '" data-goal-amount="' + g.amount + '" style="left:' + pos + '%">' +
        '<span class="fncd-goals__amt">' + amtLabel(g.amount) + '</span>' +
        '<span class="fncd-goals__ico">' + SHIELD_GIFT + '</span>' +
        '<span class="fncd-goals__lbl">' + escapeHtml(g.label) + '</span>' +
      '</li>';
    }).join('');
    wrap.innerHTML =
      '<p class="fncd-goals__msg" data-fncd-goals-msg></p>' +
      '<div class="fncd-goals__bar">' +
        '<div class="fncd-goals__track"><div class="fncd-goals__fill" data-fncd-goals-fill></div></div>' +
        '<ul class="fncd-goals__marks">' + marks + '</ul>' +
      '</div>';
    wrap.hidden = false;
    els.goalsMsg = $('[data-fncd-goals-msg]', wrap);
    els.goalsFill = $('[data-fncd-goals-fill]', wrap);
    els.goalsMarks = $$('.fncd-goals__mark', wrap);
  }

  // Cart value that counts toward the gift tiers = everything EXCEPT the free-gift products themselves.
  function qualifyingTotal(cart) {
    if (!cart || !cart.items) return 0;
    var giftIds = CONFIG.giftGoals.map(function (g) { return g.variantId; }).filter(Boolean);
    var t = 0;
    cart.items.forEach(function (it) { if (giftIds.indexOf(it.variant_id) === -1) t += it.final_line_price; });
    return t;
  }
  function isGiftVariant(vid) { return CONFIG.giftGoals.some(function (g) { return g.variantId && g.variantId === vid; }); }
  function giftLineSum(cart, field) { var s = 0; ((cart && cart.items) || []).forEach(function (it) { if (isGiftVariant(it.variant_id)) s += (it[field] || 0); }); return s; }
  // Item count shown to the customer = everything except the auto-added free gift(s).
  function displayItemCount(cart) {
    if (!cart) return 0;
    var giftQty = 0;
    (cart.items || []).forEach(function (it) { if (isGiftVariant(it.variant_id)) giftQty += it.quantity; });
    return Math.max(0, (cart.item_count || 0) - giftQty);
  }

  var giftSyncing = false;
  var pendingGiftEnter = null; // variant id that should play the "enter" animation on next render
  function setGiftBusy(on, text) {
    var s = $('[data-fncd-gift-status]'), card = $('[data-fncd-items-card]');
    if (s) { if (text) { var t = $('[data-fncd-gift-status-text]', s); if (t) t.textContent = text; } s.classList.toggle('is-visible', !!on); }
    if (card) card.classList.toggle('is-gift-syncing', !!on);
  }
  // Auto-add the free gift(s) the cart qualifies for.
  //  - Replace-lower ON  -> keep ONLY the highest reached tier's gift (swaps lower for higher).
  //  - Replace-lower OFF -> keep EVERY reached tier's gift (cumulative).
  // Remove FREE lines left over from gift offers that have ended (retired handles, or the gift tiers while auto-add is off).
  var staleGiftPurging = false;
  function purgeStaleGifts(cart) {
    if (staleGiftPurging || !cart || !cart.items) return false;
    var stale = (CONFIG.retiredGiftVariants || []).slice();
    if (!CONFIG.autoAddGift) CONFIG.giftGoals.forEach(function (g) { if (g.variantId) stale.push(g.variantId); });
    if (!stale.length) return false;
    var updates = {}, any = false;
    cart.items.forEach(function (it) {
      if (stale.indexOf(it.variant_id) !== -1 && it.final_line_price === 0) { updates[it.key] = 0; any = true; }
    });
    if (!any) return false;
    staleGiftPurging = true;
    fetchJSON(CONFIG.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () { return getCart(); })
      .then(function (nc) { staleGiftPurging = false; render(nc); })
      .catch(function () { staleGiftPurging = false; });
    return true;
  }
  function syncGiftItems(cart) {
    if (!CONFIG.autoAddGift || giftSyncing || !cart) return;
    // Warn about any tier that has an amount/label but no usable product variant (won't be added).
    CONFIG.giftGoals.forEach(function (g) {
      if (!g.variantId) { try { console.warn('[flo-cart gift] "' + g.label + '" has no product/variant selected (or the product has no variant) — it will NOT be added to cart.'); } catch (e) {} }
    });
    var goals = CONFIG.giftGoals.filter(function (g) { return g.variantId; });
    if (!goals.length) return;
    var q = qualifyingTotal(cart);
    var reached = goals.map(function (g) { return q >= g.amount; });
    var want = {};
    if (CONFIG.giftReplaceLower) {
      var hi = -1;
      for (var i = goals.length - 1; i >= 0; i--) { if (reached[i]) { hi = i; break; } }
      goals.forEach(function (g, idx) { want[g.variantId] = (idx === hi) ? 1 : 0; });
    } else {
      goals.forEach(function (g, idx) { want[g.variantId] = reached[idx] ? 1 : 0; });
    }
    var toAdd = [], toRemove = {}, changed = false;
    goals.forEach(function (g) {
      var have = 0;
      cart.items.forEach(function (it) { if (it.variant_id === g.variantId) have += it.quantity; });
      var w = want[g.variantId];
      if (w > 0 && have < w) { toAdd.push({ id: g.variantId, quantity: w - have }); changed = true; }   // /cart/add.js adds new items
      else if (w === 0 && have > 0) { toRemove[g.variantId] = 0; changed = true; }                        // /cart/update.js removes existing
    });
    if (!changed) return;
    giftSyncing = true;
    var hasAdd = toAdd.length, hasRemove = Object.keys(toRemove).length;
    var statusText = hasAdd && hasRemove ? 'Updating your free gift…' : (hasAdd ? 'Adding your free gift…' : 'Updating your free gift…');
    setGiftBusy(true, statusText);
    if (hasAdd) pendingGiftEnter = toAdd[toAdd.length - 1].id;
    var step = Promise.resolve();
    if (hasAdd) {
      step = step.then(function () {
        return fetchJSON(CONFIG.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: toAdd }) });
      });
    }
    if (hasRemove) {
      step = step.then(function () {
        return fetchJSON(CONFIG.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: toRemove }) });
      });
    }
    // small min-visible delay so the status doesn't flash-and-vanish on fast carts
    step.then(function () { return getCart(); }).then(function (nc) {
      setTimeout(function () { giftSyncing = false; setGiftBusy(false); render(nc); }, 260);
    }).catch(function (err) {
      giftSyncing = false; setGiftBusy(false); pendingGiftEnter = null;
      var msg = (err && err.data && (err.data.description || err.data.message)) || (err && err.message) || 'Free gift could not be added to cart';
      try { console.warn('[flo-cart gift] add/remove failed:', err); } catch (e) {}
      if (typeof showToast === 'function') showToast(msg);
    });
  }

  function renderGoals(cart) {
    if (!els.goals || !els.goalsFill || !CONFIG.giftGoals.length) return;
    var total = qualifyingTotal(cart);
    var goals = CONFIG.giftGoals;
    var n = goals.length, seg = 100 / n;
    var pct = 100, nextIdx = -1;
    for (var i = 0; i < n; i++) {
      if (total < goals[i].amount) {
        var prev = i === 0 ? 0 : goals[i - 1].amount;
        var frac = (total - prev) / (goals[i].amount - prev);
        if (frac < 0) frac = 0;
        pct = (i + frac) * seg;
        nextIdx = i;
        break;
      }
    }
    // the goals bar is absent when gift goals are switched off - guard before touching it
    if (els.goalsFill) els.goalsFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    (els.goalsMarks || []).forEach(function (m) {
      m.classList.toggle('is-active', total >= parseInt(m.getAttribute('data-goal-amount'), 10));
    });
    if (els.goalsMsg) {
      if (nextIdx === -1) {
        els.goalsMsg.textContent = CONFIG.giftMsgUnlocked || '';
      } else {
        els.goalsMsg.textContent = (CONFIG.giftMsgProgress || '')
          .replace(/\[gift\]/gi, goals[nextIdx].label.toLowerCase())
          .replace(/\[amount\]/gi, formatMoney(goals[nextIdx].amount - total));
      }
    }
  }

  function render(cart) {
    state.cart = cart;
    var isEmpty = !cart.items || cart.items.length === 0;

    if (els.countLabel) els.countLabel.textContent = '(' + cart.item_count + ')';
    els.empty.classList.toggle('is-visible', isEmpty);
    els.filled.style.display = isEmpty ? 'none' : '';
    els.footer.style.display = isEmpty ? 'none' : '';

    if (!isEmpty) {
      els.itemsList.innerHTML = cart.items.map(renderItem).join('');
      pendingGiftEnter = null; // consumed by the render above (enter animation applied once)
      // Show the free gift as ₹0 everywhere (line + totals), regardless of its real price.
      var giftFinal = giftLineSum(cart, 'final_line_price');
      var giftOrig = giftLineSum(cart, 'original_line_price');
      if (els.total) els.total.textContent = formatMoney(cart.total_price - giftFinal);

      var discounts = collectDiscounts(cart);
      var totalSaved = cart.total_discount || 0;

      if (els.savings) {
        els.savings.classList.toggle('is-visible', totalSaved > 0);
        if (totalSaved > 0) {
          els.savingsAmount.textContent = formatMoney(totalSaved);
          els.savingsBreakdown.innerHTML = discounts.map(function (d) {
            return '<div class="fncd-savings__line"><span>' + escapeHtml(d.title) + '</span><span>&minus;' + formatMoney(d.amount) + '</span></div>';
          }).join('');
        }
      }

      if (els.breakdown) {
        var rows = '<div class="fncd-breakdown__line"><span>Item total</span><span>' + formatMoney(cart.original_total_price - giftOrig) + '</span></div>';
        discounts.forEach(function (d) {
          rows += '<div class="fncd-breakdown__line fncd-breakdown__line--discount"><span>' + escapeHtml(d.title) + '</span><span>&minus;' + formatMoney(d.amount) + '</span></div>';
        });
        rows += '<div class="fncd-breakdown__line" style="font-weight:600;color:#000;"><span>Estimated total</span><span>' + formatMoney(cart.total_price - giftFinal) + '</span></div>';
        rows += '<p class="fncd-breakdown__note">Shipping &amp; taxes calculated at checkout</p>';
        els.breakdown.innerHTML = rows;
      }

      if (CONFIG.showRewards && els.rewardsAmount) {
        els.rewardsAmount.textContent = formatMoney(Math.round(cart.total_price * CONFIG.rewardsPercent / 100));
      }
    }

    if (purgeStaleGifts(cart)) return;
    if (CONFIG.showGiftGoals) { initGoals(); renderGoals(cart); }
    if (CONFIG.autoAddGift) syncGiftItems(cart);
    renderCouponState(cart);
    syncCartCounts(cart);
  }

  function renderCouponState(cart) {
    if (!els.couponApplied) return;
    var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    if (applied.length > 0) {
      els.couponCode.textContent = applied.map(function (d) { return d.code; }).join(', ');
      els.couponApplied.classList.add('is-visible');
    } else {
      els.couponApplied.classList.remove('is-visible');
    }
  }

  function syncCartCounts(cart) {
    var count = cart.item_count;
    document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.tagName.toLowerCase() === 'cart-count') {
        if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      }
    });
    // this theme's header cart bubble (the cart one — not the wishlist/recently-viewed bubbles)
    document.querySelectorAll('.jhx-cart__c:not([data-jhwr-count])').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
    try {
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'flo-native-cart', cart: cart });
      }
    } catch (e) { /* theme pubsub not present on this template */ }
    document.dispatchEvent(new CustomEvent('flo-native-cart:updated', { detail: { cart: cart } }));
  }

  /* Upsell cards sit in a <template> and their images carry data-kr-src until needed. They are expanded on the
     visitor's first tap / touch / key press (every way the drawer can appear - open(), add-to-cart, quick add -
     starts with one) and again in open() as a safety net. Nothing of this runs during page load. */
  function krExpandUpsells() {
    var kTpl = root.querySelector('template[data-fncd-upsells-tpl]');
    if (kTpl) kTpl.parentNode.replaceChild(kTpl.content, kTpl);
    root.querySelectorAll('img[data-kr-src]').forEach(function (i) { i.src = i.getAttribute('data-kr-src'); i.removeAttribute('data-kr-src'); });
  }
  ['pointerdown', 'touchstart', 'keydown', 'click'].forEach(function (ev) { window.addEventListener(ev, krExpandUpsells, { capture: true, passive: true, once: true }); });

  /* ---------- open / close ---------- */
  function open() {
    krExpandUpsells();
    document.querySelectorAll('link[data-kr-full]').forEach(function (l) { l.href = l.getAttribute('data-kr-full'); l.removeAttribute('data-kr-full'); });
    if (state.open) { refresh(); return; }
    state.open = true;
    root.classList.add('kr-opened', 'fncd-open');
    root.removeAttribute('inert');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fncd-lock');
    refresh();
  }
  function close() {
    state.open = false;
    closeVarMenus();
    root.classList.remove('fncd-open');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');
    document.documentElement.classList.remove('fncd-lock');
  }
  function refresh() {
    return getCart().then(render).catch(function () { showToast('Could not load your cart. Please retry.'); });
  }

  /* ---------- interactions ---------- */
  function withBusy(el, promise) {
    if (state.busy) return Promise.resolve();
    state.busy = true;
    if (el) el.classList.add('fncd-busy');
    return promise
      .catch(function (err) { showToast(err && err.message ? err.message : 'Something went wrong'); })
      .then(function () {
        state.busy = false;
        if (el) el.classList.remove('fncd-busy');
      });
  }

  // ---- Upsell variant dropup helpers ----
  function closeVarMenus() {
    // sheets get portaled out of the scroller on open — put them back home first
    $$('[data-fncd-var-menu]').forEach(function (m) {
      if (m._fncdHome && m.parentElement !== m._fncdHome) m._fncdHome.appendChild(m);
      m.hidden = true;
    });
    $$('[data-fncd-variant].is-open').forEach(function (w) {
      w.classList.remove('is-open');
      var b = w.querySelector('[data-fncd-var-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    var backdrop = $('[data-fncd-var-backdrop]');
    if (backdrop) backdrop.hidden = true;
  }
  function resolveVariant(menu) {
    var groups = menu.querySelectorAll('[data-fncd-opt-group]');
    var chosen = [], complete = true;
    groups.forEach(function (g) {
      var sel = g.querySelector('[data-fncd-optval].is-selected');
      if (sel) chosen.push(sel.getAttribute('data-val')); else complete = false;
    });
    var confirm = menu.querySelector('[data-fncd-var-confirm]');
    if (!confirm) return;
    var lbl = confirm.querySelector('span') || confirm;
    confirm.removeAttribute('data-vid');
    if (!complete) { confirm.disabled = true; lbl.textContent = 'Select options'; return; }
    var variants = [];
    try { variants = JSON.parse(menu.getAttribute('data-fncd-variants') || '[]'); } catch (e) {}
    var match = variants.filter(function (v) {
      return v.opts && v.opts.length === chosen.length && v.opts.every(function (o, i) { return String(o) === chosen[i]; });
    })[0];
    if (match && match.avail) { confirm.disabled = false; confirm.setAttribute('data-vid', match.id); lbl.textContent = 'Add to cart'; }
    else if (match) { confirm.disabled = true; lbl.textContent = 'Sold out'; }
    else { confirm.disabled = true; lbl.textContent = 'Unavailable'; }
  }
  function positionVarMenu(btn, menu) {
    // Mobile: fixed-coordinate dropup math is unreliable in mobile Safari (dynamic
    // viewport, tap-triggered scroll events) — render as a full-width bottom sheet.
    if (window.innerWidth < 768) {
      menu.classList.add('fncd-vmenu--sheet');
      menu.style.position = 'fixed';
      menu.style.left = '0';
      menu.style.width = '100%';
      menu.style.top = 'auto';
      menu.style.bottom = '0';
      menu.style.maxHeight = '70vh';
      var backdrop = $('[data-fncd-var-backdrop]');
      if (backdrop) backdrop.hidden = false;
      return;
    }
    menu.classList.remove('fncd-vmenu--sheet');
    var r = btn.getBoundingClientRect();
    var w = Math.min(Math.max(r.width, 280), window.innerWidth - 20);
    var left = r.left;
    if (left + w > window.innerWidth - 10) left = window.innerWidth - 10 - w;
    if (left < 10) left = 10;
    menu.style.position = 'fixed';
    menu.style.left = left + 'px';
    menu.style.width = w + 'px';
    menu.style.top = 'auto';
    menu.style.bottom = (window.innerHeight - r.top + 6) + 'px';   // dropup: sits just above the button
    menu.style.maxHeight = Math.max(160, Math.min(340, r.top - 16)) + 'px';
  }
  // Outer scrolling detaches the fixed menu, so close it — but NOT when scrolling inside the menu itself.
  window.addEventListener('scroll', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-fncd-var-menu]')) return;
    // mobile bottom sheet has its own backdrop; iOS fires stray scroll events on tap
    if ($('.fncd-vmenu--sheet:not([hidden])')) return;
    closeVarMenus();
  }, true);
  window.addEventListener('resize', function () {
    // iOS toolbar show/hide fires resize; the bottom sheet doesn't depend on coordinates
    if ($('.fncd-vmenu--sheet:not([hidden])')) return;
    closeVarMenus();
  });

  root.addEventListener('click', function (e) {
    var t = e.target;

    // ---- Upsell variant dropup ----
    if (t.closest('[data-fncd-var-backdrop]')) { e.preventDefault(); closeVarMenus(); return; }
    var varToggle = t.closest('[data-fncd-var-toggle]');
    if (varToggle) {
      e.preventDefault(); e.stopPropagation();
      var vwrap = varToggle.closest('[data-fncd-variant]');
      var wasOpen = vwrap.classList.contains('is-open');
      closeVarMenus();
      if (!wasOpen) {
        var vmenu = vwrap.querySelector('[data-fncd-var-menu]');
        vmenu.querySelectorAll('[data-fncd-optval].is-selected').forEach(function (x) { x.classList.remove('is-selected'); });
        vmenu.querySelectorAll('.fncd-vopt__name[data-name]').forEach(function (n) { n.textContent = n.getAttribute('data-name'); });
        resolveVariant(vmenu);
        vmenu._fncdHome = vwrap;
        vmenu.hidden = false;
        positionVarMenu(varToggle, vmenu);
        // iOS Safari traps position:fixed inside -webkit-overflow-scrolling scrollers,
        // so the mobile sheet must live outside .fncd-body while open
        if (vmenu.classList.contains('fncd-vmenu--sheet')) root.appendChild(vmenu);
        vwrap.classList.add('is-open');
        varToggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    // pick a value within an option group (Size / Color …)
    var optVal = t.closest('[data-fncd-optval]');
    if (optVal) {
      e.preventDefault(); e.stopPropagation();
      if (optVal.classList.contains('is-unavail')) return;
      var grp = optVal.closest('[data-fncd-opt-group]');
      grp.querySelectorAll('[data-fncd-optval]').forEach(function (x) { x.classList.toggle('is-selected', x === optVal); });
      var gname = grp.querySelector('.fncd-vopt__name');
      if (gname && optVal.classList.contains('fncd-vopt__swatch')) {
        gname.textContent = (gname.getAttribute('data-name') || '') + ' · ' + optVal.getAttribute('data-val');
      }
      resolveVariant(optVal.closest('[data-fncd-var-menu]'));
      return;
    }
    // confirm → add the resolved variant
    var confirmBtn = t.closest('[data-fncd-var-confirm]');
    if (confirmBtn) {
      e.preventDefault(); e.stopPropagation();
      if (confirmBtn.disabled) return;
      var vid = confirmBtn.getAttribute('data-vid');
      if (!vid) return;
      // when the sheet is portaled to root, walk back to its home card via _fncdHome
      var cmenu = confirmBtn.closest('[data-fncd-var-menu]');
      var ccard = (cmenu && cmenu._fncdHome) ? cmenu._fncdHome.closest('.fncd-upsell-card') : confirmBtn.closest('.fncd-upsell-card');
      var cadd = ccard && ccard.querySelector('[data-fncd-var-toggle]');
      var clabel = cadd && cadd.querySelector('[data-fncd-add-label]');
      closeVarMenus();
      withBusy(cadd, addItem(vid).then(function () {
        if (clabel) { clabel.textContent = 'ADDED'; setTimeout(function () { clabel.textContent = 'ADD'; }, 1500); }
        return getCart().then(render);
      }));
      return;
    }
    // clicks inside the open dropup never fall through (don't close it, don't navigate)
    if (t.closest('[data-fncd-var-menu]')) { e.stopPropagation(); return; }
    // any other click dismisses an open dropup
    closeVarMenus();

    // Explicit close buttons, OR any click on the dimmed area outside the cart panel.
    if (t.closest('[data-fncd-close]') ||
        (root.classList.contains('fncd-open') && !t.closest('.fncd-panel') && !t.closest('[data-fncd-var-menu]'))) {
      close(); return;
    }

    var minus = t.closest('[data-fncd-minus]');
    var plus = t.closest('[data-fncd-plus]');
    var remove = t.closest('[data-fncd-remove]');
    if (minus || plus || remove) {
      var idx = Number((minus || plus || remove).getAttribute(minus ? 'data-fncd-minus' : plus ? 'data-fncd-plus' : 'data-fncd-remove'));
      var item = state.cart && state.cart.items[idx];
      if (!item) return;
      var qty = remove ? 0 : (minus ? item.quantity - 1 : item.quantity + 1);
      var line = t.closest('li');
      withBusy(line, changeLine(item.key, Math.max(0, qty)).then(render));
      return;
    }

    var upsellAdd = t.closest('[data-fncd-upsell-add]');
    if (upsellAdd) {
      e.stopPropagation();
      var label = upsellAdd.querySelector('[data-fncd-add-label]');
      withBusy(upsellAdd, addItem(upsellAdd.getAttribute('data-fncd-upsell-add')).then(function () {
        if (label) { label.textContent = 'ADDED'; setTimeout(function () { label.textContent = 'ADD'; }, 1500); }
        return getCart().then(render);
      }));
      return;
    }

    var upsellCard = t.closest('[data-fncd-upsell-url]');
    if (upsellCard && !t.closest('button')) {
      window.location.href = upsellCard.getAttribute('data-fncd-upsell-url');
      return;
    }

    var tab = t.closest('[data-fncd-tab]');
    if (tab) {
      $$('.fncd-upsells__tab').forEach(function (b) { b.classList.toggle('is-active', b === tab); });
      var id = tab.getAttribute('data-fncd-tab');
      $$('[data-fncd-track]').forEach(function (track) {
        if (track.getAttribute('data-fncd-track') === id) track.removeAttribute('hidden');
        else track.setAttribute('hidden', '');
      });
      return;
    }

    var arrow = t.closest('[data-fncd-arrow]');
    if (arrow) {
      var visible = $('[data-fncd-track]:not([hidden])');
      if (visible) {
        var end = visible.scrollLeft + visible.clientWidth >= visible.scrollWidth - 8;
        visible.scrollTo({ left: end ? 0 : visible.scrollLeft + 226, behavior: 'smooth' });
      }
      return;
    }

    if (t.closest('[data-fncd-savings]') && !t.closest('[data-fncd-coupon-remove]')) {
      els.savings.classList.toggle('is-expanded');
      return;
    }
    if (t.closest('[data-fncd-total-toggle]')) {
      els.footer.classList.toggle('is-expanded');
      return;
    }

    if (t.closest('[data-fncd-checkout]')) {
      window.location.href = '/checkout';
      return;
    }

    if (t.closest('[data-fncd-coupon-remove]')) {
      withBusy(els.couponApplied, updateDiscount('').then(function () { return getCart().then(render); }));
      return;
    }
    if (t.closest('[data-fncd-coupon-apply]')) { applyCoupon(); return; }
  });

  function applyCoupon() {
    var code = els.couponInput ? els.couponInput.value.trim() : '';
    if (!code) return;
    els.couponError.classList.remove('is-visible');
    withBusy(els.couponInput.parentElement, updateDiscount(code).then(function () {
      return getCart().then(function (cart) {
        var found = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (found && found.applicable) {
          els.couponInput.value = '';
          els.couponApply.classList.remove('is-visible');
          render(cart);
        } else {
          if (found) updateDiscount('');
          els.couponError.textContent = 'This coupon is invalid or not applicable to your cart.';
          els.couponError.classList.add('is-visible');
          render(cart);
        }
      });
    }));
  }

  if (els.couponInput) {
    els.couponInput.addEventListener('input', function () {
      els.couponApply.classList.toggle('is-visible', els.couponInput.value.trim().length > 0);
      els.couponError.classList.remove('is-visible');
    });
    els.couponInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') applyCoupon(); });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });

  /* ---------- public API (same entry point Shopflo exposed) ---------- */
  window.handleFloCartBtn = open;
  window.FloNativeCart = { open: open, close: close, refresh: refresh };
  // A cart that still holds an ended offer's free gift is cleaned on page load, without waiting for the drawer to open.
  if (CONFIG.staleGiftInCart) getCart().then(render).catch(function () {});

  /* keep in sync when the theme adds items without opening the drawer */
  try {
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (payload && payload.source !== 'flo-native-cart' && payload.cart && state.open) render(payload.cart);
      });
    }
  } catch (e) { /* no pubsub */ }
})();
